import React from "react";
import LoadingOverlay from "react-loading-overlay";
import HomeNavBar from "../components/HomeNavBar";
import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import { Link, useNavigate } from "react-router-dom";
import CartData from "./CartData";

const ViewCart = () => {
  const state = useSelector((state) => state.cartReducer);
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <LoadingOverlay active={state.loading} spinner text="Loading...">
      <div className="main-landing-page traning-landing-page landing-container">
        {/* navbar */}
        <HomeNavBar />
       <br/>
        <div className="container">
          <div className="row cource-section">
            <div className="col-lg-12 mb-3">
              <div className="box">
                <div class="paths-content-highlight paths-aside-box show-for-large-up">
                  <div class="paths-aside-scrollable">
                    <div className="cert-details-div">
                      <Link
                        to={"/certifications"}
                        className="d-inline-block mt-2"
                        title={"Certifications"}
                      >
                        <i className="ti-arrow-left font-sm text-white"></i>
                      </Link>
                      <h1 className="text-white text-center cer-details-heading">
                          Cart Details
                      </h1>
                    </div>
                    <CartData />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer */}
        <Footer />
      </div>
    </LoadingOverlay>
  );
};

export default ViewCart;
